// extracted by mini-css-extract-plugin
export default {"buttonClose":"styles-scoped__buttonClose--zkTGf","modalMap":"styles-scoped__modalMap--EXHvJ"};